exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button .zb-spin[data-v-2b2351e4]{display:none}button.loading .zb-spin[data-v-2b2351e4]{display:inline-block}", ""]);

// exports
